module.exports = __webpack_public_path__ + "img/service-petrifaction.159249f4.jpg";